import { ErrorHandler, Injectable, Injector } from '@angular/core';

import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { ErrorDialogComponent } from './error-dialog.component';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class AppErrorHandler implements ErrorHandler {

  /**
   * モーダルダイアログ
   */
  bsModalRef: BsModalRef;

  /**
   * コンストラクタ
   *
   * @param injector Injector
   */
  constructor(
    private injector: Injector,
  ) { }

  /**
   * エラーハンドリング
   *
   * @param error エラー情報
   */
  handleError(error: Error) {

    const modalService = this.injector.get(BsModalService);

    const initialState = {
      title: 'エラーが発生しました',
      message: 'しばらくしてからやり直してください',
      detail: error.message,
    };

    // HTTP 503 エラーの場合は、オンライン開閉用メッセージとする
    if (error instanceof HttpErrorResponse) {
      if (error.status === 503) {
        initialState.message = 'ただいまの時間は利用可能時間外です。';
        initialState.detail = '';
      }
    }

    this.bsModalRef = modalService.show(ErrorDialogComponent, { initialState, class: 'modal-dialog-centered' });
    this.bsModalRef.content.closeBtnName = 'Close';
  }
}



// WEBPACK FOOTER //
// ./src/app/error-handler/app.error-handler.ts